import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import styles from "./styles.module.css";
import { EditOutlined } from "@mui/icons-material";
import CoverImageUploader from "./cover-image-uploader";
import { useTheme } from "../../../../../../context/themeContext";
import UploadProjectImage from "./upload-profile-image";
import EditProjectImage from "./edit";
import DeleteProjectImage from "./delete";
import { useDispatch, useSelector } from "react-redux";
import { setIsModalProjectOpen } from "../../../../../../store/slices/profile/projectCoverImageSlice";

const ProjectCoverImage = ({ project }) => {
  const { theme } = useTheme();
  const dispatch = useDispatch();
  const { croppedImage, selectedProjectImage, isDeleteProjectImageOpen } =
    useSelector((state) => state.projectCoverImage);

  const [project_cover_image, setProjectCoverImage] = useState(croppedImage);

  useEffect(() => {
    setProjectCoverImage(croppedImage);
  }, [croppedImage]);

  return (
    <Box className={styles.skillsImg}>
      <Box
        className={styles.primaryImg}
        sx={{
          backgroundImage: project_cover_image
            ? `url(${project_cover_image})`
            : "none",
        }}
      >
        {!project_cover_image && <CoverImageUploader />}
        <Box className={styles.options}>
          {project_cover_image && (
            <Box
              className={styles.Cameraupload}
              onClick={() => dispatch(setIsModalProjectOpen(true))}
            >
              <EditOutlined
                fontSize="16px"
                sx={{ color: theme.palette.darkgrey.darkgrey400 }}
              />
            </Box>
          )}
        </Box>
      </Box>
      <UploadProjectImage
        projectCoverImage={project_cover_image}
        project={project}
      />
      {selectedProjectImage && <EditProjectImage project={project} />}
      {isDeleteProjectImageOpen && <DeleteProjectImage />}
    </Box>
  );
};

export default ProjectCoverImage;
